import { render, staticRenderFns } from "./fragment.vue?vue&type=template&id=3661066a&"
import script from "./fragment.vue?vue&type=script&lang=js&"
export * from "./fragment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3661066a')) {
      api.createRecord('3661066a', component.options)
    } else {
      api.reload('3661066a', component.options)
    }
    module.hot.accept("./fragment.vue?vue&type=template&id=3661066a&", function () {
      api.rerender('3661066a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/info-pages/fragment.vue"
export default component.exports